<template>
  <div>
    <div class="navbarbox">
      <van-nav-bar :title="titlename" left-arrow @click-left="backgoto" />
    </div>
    <div class="contents-containers">
      <!-- 卡片信息容器 -->
      <div class="form-box">
        <div class="cu-form-group">
          <div class="title">
            备注姓名
            <span class="global-input-must-tip">*</span>
          </div>
          <input type="text" name="name" v-model="formTemp.name" placeholder="请输入姓名" maxlength="10" placeholder-class="global-input-placeholder" />
        </div>
        <div class="cu-form-group">
          <div class="title">
            手机号
            <span class="global-input-must-tip">*</span>
          </div>
          <input type="text" maxlength="11" name="mobile_account" v-model="formTemp.mobile_account" placeholder="请输入手机号" placeholder-class="global-input-placeholder" />
        </div>
        <div class="cu-form-group">
          <div class="title">电话</div>
          <input type="text" maxlength="11" name="tel" v-model="formTemp.tel" placeholder="请输入电话号" placeholder-class="global-input-placeholder" />
        </div>
        <div class="cu-form-group" @click="linktoLocation" style="margin-left:0.2702702702702703rem ">
          <div class="title flex">
            <span>地址</span>
          </div>
          <div class="choose-box" :hidden="!formTemp.location">{{formTemp.location}}</div>
          <input type="text" :hidden="hiddenInput" name="longitude" v-model="formTemp.longitude" />
          <input type="text" :hidden="hiddenInput" name="latitude" v-model="formTemp.latitude" />
          <input type="text" :hidden="hiddenInput" name="location" v-model="formTemp.location" />
          <div class="flex justify-center align-center">
            <span class="global-fonts26 text-blue" v-if="!formTemp.location">请选择定位</span>
            <img class="icon-rigjt-enter" :src="homeIconEnter" />
          </div>
        </div>
        <div class="cu-form-group">
          <div class="title">详细地址</div>
          <input type="text" name="detail" maxlength="30" @input="detailVerify" v-model="formTemp.detail" placeholder="例18号楼505室" placeholder-class="global-input-placeholder" />
        </div>
        <div class="cu-form-group">
          <div class="title">公司</div>
          <input type="span" @input="nameVerify" name="company_name" maxlength="30" v-model="formTemp.company_name" placeholder="请输入公司名称" placeholder-class="global-input-placeholder" />
        </div>
        <div class="cu-form-group">
          <div class="title">职位</div>
          <input type="text" name="job" @input="jobVerify" v-model="formTemp.job" placeholder="请输入职位名称" maxlength="10" placeholder-class="global-input-placeholder" />
        </div>
        <div class="cu-form-group">
          <div class="title">公司网址</div>
          <input type="text" name="website" v-model="formTemp.website" placeholder="请输入公司网址" maxlength="10" placeholder-class="global-input-placeholder" />
        </div>
        <div class="cu-form-group">
          <div class="title">QQ</div>
          <input type="text" maxlength="20" name="qq" v-model="formTemp.qq" placeholder="请输入QQ号" placeholder-class="global-input-placeholder" />
        </div>
        <div class="cu-form-group">
          <div class="title">邮箱地址</div>
          <input type="text" maxlength="20" name="email" v-model="formTemp.email" placeholder="请输入邮箱地址" placeholder-class="global-input-placeholder" />
        </div>
      </div>
      <div class="btns-box flex justify-center align-center">
        <button form-type="submit" class="cu-btn form-btn-submits" @click="formSubmit">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
import { saveScanCard } from "../../api/api";
import navbar from "../public/navbar.vue";
import Vue from "vue";
import { Toast, Dialog } from "vant";
Vue.use(Toast);

export default {
  name: "cartform",
  components: { navbar },
  data () {
    return {
      titlename: "新增人员",
      hiddenInput: true,
      formTemp: {
        name: '',
        mobile_account: '',
        tel: '',
        location: '',
        longitude: '',
        latitude: '',
        detail: '',
        company_name: '',
        job: '',
        website: '',
        qq: '',
        email: ''
      },
      homeIconEnter: require("../../assets/images/home_icon_enter.png"),
    };
  },
  created: function () {
    document.title = "编辑名片";
    this.getformdata();
    this.getLocation();
  },
  methods: {
    jobVerify: function () {
      var job = this.formTemp.job;
      if (job.length > 9) {
        Toast({
          message: "职称最多10字哦！",
          duration: 2000
        });
      }
    },
    nameVerify: function () {
      var company_name = this.formTemp.company_name;
      if (company_name.length > 29) {
        Toast({
          message: "公司名称最多30字哦！",
          duration: 2000
        });
      }
    },
    detailVerify: function () {
      var detail = this.formTemp.detail;
      if (detail.length > 29) {
        Toast({
          message: "详细地址最多30字哦！",
          duration: 2000
        });
      }
    },
    linktoLocation: function () {
      this.$store.dispatch("changeScancardFun", this.formTemp);
      this.$router.push({
        name: "map"
      });
    },
    //验证手机号
    reMobile: function (mobile) {
      let regStr = /^0?(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      return regStr.test(mobile);
    },

    //验证电话
    reTel: function (tel) {
      let regStr = /^0\d{2,3}-?\d{7,8}$/;
      return regStr.test(tel);
    },

    //验证公司网址
    reWeb: function (web) {
      let regStr = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      return regStr.test(web);
    },

    //验证QQ
    reQq: function (qq) {
      let regStr = /^[a-zA-Z0-9]+([._-]*[a-zA-Z0-9]*)*@[a-zA-Z0-9]+.[a-zA-Z0-9{2,5}$]/;
      return regStr.test(qq);
    },

    //验证邮箱地址
    reEmail: function (email) {
      let regStr = /^[a-zA-Z0-9]+([._-]*[a-zA-Z0-9]*)*@[a-zA-Z0-9]+.[a-zA-Z0-9{2,5}$]/;
      return regStr.test(email);
    },
    //获取定位
    getLocation () {
      /*判断是第一次加载还是从location页面返回
        如果从location页面返回，会传递用户选择的地点*/
      let locatInfo = this.$store.getters.getLocationinfo;
      if (locatInfo.address != null && locatInfo.address != "") {
        let urlStr = JSON.parse(locatInfo.location);
        //设置变量 address 的值
        this.formTemp.location = locatInfo.address;
        this.formTemp.longitude = urlStr.lng;
        this.formTemp.latitude = urlStr.lat;
        this.formTemp.detail = locatInfo.name;
      }
    },
    backgoto: function () {
      //返回时清空数据
      let formdata = {};
      let LOCATION_INFO = {
        location: '',
        name: "",
        address: '',
      }
      this.$store.dispatch("changeScancardFun", formdata);
      this.$store.dispatch("changemapFun", LOCATION_INFO);
      this.$router.go(-1);
    },
    //暂存表单数据
    getformdata: function () {
      let that = this;
      let formdata = that.$store.getters.getScancarddata;

      if (formdata) {
        that.formTemp = formdata;
      }
    },
    //提交表单
    formSubmit: function () {
      let items = this.formTemp,
        remark_name = items.name.trim(),
        mobile_account = items.mobile_account.trim(),
        tel = items.tel.trim(),
        location = items.location.trim(),
        longitude = items.longitude,
        latitude = items.latitude,
        detail = items.detail.trim(),
        company_name = items.company_name.trim(),
        job = items.job.trim(),
        website = items.website.trim(),
        qq = items.qq.trim(),
        email = items.email.trim();

      if (!remark_name) {
        Dialog({ message: "请输入姓名" });
        return;
      }
      if (!mobile_account) {
        Dialog({ message: "请输入手机号" });
        return;
      }
      if (!this.reMobile(mobile_account)) {
        Dialog({ message: "手机号格式错误，请重新填写" });
        return;
      }
      if (tel && !this.reTel(tel)) {
        Dialog({ message: "电话号格式错误，请重新填写" });
        return;
      }
      if (website && !this.reWeb(website)) {
        Dialog({ message: "公司网址格式错误，请重新填写" });
        return;
      }
      if (qq && !this.reQq(qq)) {
        Dialog({ message: "QQ号格式错误，请重新填写" });
        return;
      }
      if (email && !this.reEmail(email)) {
        Dialog({ message: "邮箱地址格式错误，请重新填写" });
        return;
      }

      let formjson = {
        remark_name: remark_name,
        mobile_account: mobile_account,
        tel: tel,
        location: location,
        longitude: longitude,
        latitude: latitude,
        detail: detail,
        company_name: company_name,
        job: job,
        website: website,
        qq: qq,
        email: email,
      }
      saveScanCard(formjson).then(res => {
        if (res.code == 200) {
          Dialog.alert({
            title: "提示",
            message: "提交成功"
          }).then(() => {
            let formdata = {};
            let LOCATION_INFO = {
              location: '',
              name: "",
              address: '',
            }
            this.$store.dispatch("changemapFun", LOCATION_INFO);
            this.$store.dispatch("changeScancardFun", formdata);
            this.$router.go(-1);
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.contents-containers {
  width: 100%;
  padding-bottom: 0.7rem;
  padding-top: 50px;
}

/* 中间 */
.form-box {
  padding-bottom: 0.7567567567567568rem;
  margin-top: -0.3rem;
}
.cu-form-group {
  background-color: var(--white);
  padding: 0.02702702702702703rem 0.8108108108108109rem;
  display: flex;
  align-items: center;
  min-height: 2.7027027027027026rem;
  justify-content: space-between;
  border-top: 0.02702702702702703rem solid #eee;
}
.cu-form-group .title {
  width: 4rem;
  display: flex;
  align-items: center;
  text-align: justify;
  position: relative;
  padding-right: 0.8108108108108109rem;
  line-height: normal;
  font-size: 0.8108108108108109rem;
  color: #333;
}
.cu-form-group input {
  flex: 1;
  padding-right: 0.5405405405405406rem;
  border: 0;
  font-size: 0.8108108108108109rem;
  color: #555;
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}
.icon-rigjt-enter {
  width: 0.3783783783783784rem;
  height: 0.7027027027027027rem;
  margin-left: 0.5405405405405406rem;
}
.text-blue {
  font-size: 0.7027027027027027rem;
  color: #69f;
}
.global-fonts26 {
  font-size: 0.7027027027027027rem;
}

.choose-box {
  flex: 1;
  width: 11.432432432432432rem;
  white-space: wrap;
  line-height: 0.9rem;
  font-size: 0.8108108108108109rem;
  margin-left: -0.2rem;
}
.form-btn-submits {
  width: 16.216216216216218rem;
  height: 2.4324324324324325rem;
  background-image: linear-gradient(90deg, #ffbd0a, #f9da5b);
  border-radius: 1.2162162162162162rem;
  color: #fff;
  font-size: 0.7567567567567568rem;
  border: 0;
}
.btns-box {
  width: 100%;
  margin-top: 0.7027027027027027rem;
  padding-bottom: 1.027027027027027rem;
  position: relative;
  z-index: 1;
}
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.global-input-must-tip {
  font-size: 0.7027027027027027rem;
  color: #f5495a;
  margin-left: 0.1891891891891892rem;
}
.navbarbox {
  overflow: hidden;
}
.van-nav-bar {
  height: 50px;
  line-height: 50px;
  top: 0;
  position: fixed;
  border-bottom: 1px solid #eee;
  width: 100%;
  overflow: hidden;
}
.van-nav-bar__title {
  font-weight: bold;
  font-size: 0.8rem;
}
.van-icon-arrow-left:before {
  color: #333;
  font-size: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/addperson.vue